import { z, isoZ } from 'my-zod'

const OutfitterContactDepartmentAssociationEnum = z
  .enum(['Finance', 'Contract', 'TechnicalService', 'Marketing', 'Legal'])
  .setEnumLabels({
    Finance: 'Finance',
    Contract: 'Contract',
    TechnicalService: 'Technical Service',
    Marketing: 'Marketing',
    Legal: 'Legal'
  })

export const OutfitterContactDepartmentAssociationLabels = OutfitterContactDepartmentAssociationEnum.enumLabels

export const OutfitterContactRoleEnum = z
  .enum([
    'OwnerInvestor',
    'GeneralManager',
    'OfficeManager',
    'ServiceManager',
    'Tech',
    'Agent',
    'Bookkeeper',
    'VehicleReceiving',
    'GeneralReceiving'
  ])
  .setEnumLabels({
    OwnerInvestor: 'Owner / Investor',
    GeneralManager: 'General Manager',
    OfficeManager: 'Office Manager',
    ServiceManager: 'Service Manager',
    Tech: 'Tech',
    Agent: 'Agent',
    Bookkeeper: 'Bookkeeper',
    VehicleReceiving: 'Vehicle Receiving',
    GeneralReceiving: 'General Receiving'
  })
export type OutfitterContactRoleEnum = z.infer<typeof OutfitterContactRoleEnum>

export const outfitterContactsModel = z.object({
  id: z.string().uuid(),
  shortId: z.string().nonempty(),
  outfitterIds: z.number().array(),
  firstName: z.string().nonempty(),
  lastName: z.string(),
  email: z.string().email().nonempty(),
  jobTitle: z.string().nullable(),
  businessPhone: z.string().nullable(),
  mobilePhone: z.string().nullable(),
  notes: z.string().nullable(),
  decisionPower: z.enum(['S', 'M', 'L', 'XL']).nullable(),
  roles: OutfitterContactRoleEnum.array().nullable(),
  status: z.enum(['Active', 'Inactive']),
  friendFoe: z.enum(['Advocate', 'Supporter', 'Neutral', 'Skeptic', 'Hostile']).nullable().setLabel('Friend/Foe'),
  departments: OutfitterContactDepartmentAssociationEnum.array().nullable(),
  avatarImageUrl: z.string().nullable(),
  lastCommunicationDate: isoZ.date().nullable().setLabel('Last Contacted Date'),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterContactsModel = z.infer<typeof outfitterContactsModel>
